export enum HalalTradingPageSection {
  Catalog = 'catalog',
  MyCompany = 'myCompany',
}
